'use client'

import { Button } from '@desoutter/uikit'
import CartForm from './CartForm'
import { GetAQuoteFormFragment } from './GetaquoteForm.generated'
export default function GetaquoteForm({
	getAQuoteFragment,
	followUpUrl,
}: {
	getAQuoteFragment: GetAQuoteFormFragment
	followUpUrl: string
}) {
	const handleButtonClick = (event: React.MouseEvent) => {
		window.location.href = followUpUrl
	}

	return (
		<div className="max-w-[600px] mx-auto mt-10 xl:mt-20 mb-16">
			<div>
				<CartForm getAQuoteFragment={getAQuoteFragment} />
				<div className="flex justify-center mt-8">
					<Button
						title={getAQuoteFragment.nextStepButtonLabel}
						noIcon
						onClick={handleButtonClick}
						className="pt-3.5"
					>
						{getAQuoteFragment.nextStepButtonLabel}
					</Button>
				</div>
			</div>
		</div>
	)
}
